import React from "react";

const STATUS_TONE = {
  Available: "green",
  Assigned: "blue",
  Maintenance: "amber",
  Retired: "gray",
  Lost: "red",
};
const ASSIGNMENT_TONE = { ACTIVE: "blue", RETURNED: "gray", LOST: "red" };
const ASSIGNMENT_LABEL = {
  ACTIVE: "Active",
  RETURNED: "Returned",
  LOST: "Lost",
};
const CONDITION_TONE = {
  New: "green",
  Good: "green",
  Fair: "amber",
  Poor: "red",
  Damaged: "red",
};

export const ASSET_STATUSES = [
  "Available",
  "Assigned",
  "Maintenance",
  "Retired",
  "Lost",
];
export const ASSET_CONDITIONS = ["New", "Good", "Fair", "Poor", "Damaged"];

const Badge = ({ tone, children }) => (
  <span className={`asset-badge asset-badge--${tone || "gray"}`}>
    {children}
  </span>
);

export const AssetStatusBadge = ({ status }) => (
  <Badge tone={STATUS_TONE[status]}>{status || "—"}</Badge>
);

export const AssignmentStatusBadge = ({ status }) => (
  <Badge tone={ASSIGNMENT_TONE[status]}>
    {ASSIGNMENT_LABEL[status] || status || "—"}
  </Badge>
);

/** Condition shown as a small colored dot + text. */
export const ConditionText = ({ condition }) =>
  condition ? (
    <span
      className={`asset-condition asset-condition--${CONDITION_TONE[condition] || "gray"}`}
    >
      {condition}
    </span>
  ) : (
    "—"
  );
